export default "__VITE_ASSET__D8Q0QXor__"